import { Option } from '../../components/SearchSelectFilter/SearchSelectFilter';

const mapSelectOption = (allOptions: Option[], optionValue: any): Option => {
  return allOptions.find((optionObj: Option) => optionObj.value === optionValue) as Option;
};

export default mapSelectOption;
